"use strict";
exports.__esModule = true;
exports.FirstAvailableSaleVariant = exports.FirstSaleVariant = exports.FirstAvailableVariantOnly = exports.FirstAvailableVariant = exports.FirstVariant = void 0;
//Returns the first variant in the product, regardless of anything
var FirstVariant = function (product, template) {
    return [product.variants[0]];
};
exports.FirstVariant = FirstVariant;
//Returns the first available variant (if any), otherwise the first variant.
var FirstAvailableVariant = function (product, template) {
    var v = product.variants.find(function (v) { return template.isVariantAvailable(v); }) || product.variants[0];
    return [v];
};
exports.FirstAvailableVariant = FirstAvailableVariant;
//Returns the first available variant if any variant is in stock.
var FirstAvailableVariantOnly = function (product, template) {
    var v = product.variants.find(function (v) { return template.isVariantAvailable(v); });
    return v ? [v] : [];
};
exports.FirstAvailableVariantOnly = FirstAvailableVariantOnly;
//Returns the first variant on sale
var FirstSaleVariant = function (product, template) {
    return [product.variants.find(function (v) { return template.isVariantOnSale(v); })];
};
exports.FirstSaleVariant = FirstSaleVariant;
//First available sale variant, otherwise first sale variant.
var FirstAvailableSaleVariant = function (product, t) {
    var v = product.variants.find(function (v) {
        return t.isVariantOnSale(v) && t.isVariantAvailable(v);
    });
    return v ? [v] : exports.FirstSaleVariant(product, t);
};
exports.FirstAvailableSaleVariant = FirstAvailableSaleVariant;
//# sourceMappingURL=First.js.map